export default __webpack_public_path__ + "static/media/Chestguard of the Martial Paragon.c453a973.jpg";